import angular, { INgModelController, ITimeoutService } from 'angular';
import { createJSONEditor, JsonEditor, MenuItem, Mode, toJSONContent } from 'vanilla-jsoneditor/standalone.js';

let index = 0;

export class JsonEditorComponent {
  static $inject = ['$element', '$timeout'];

  id = `json-editor-${++index}`;
  editor: JsonEditor;
  mode: 'text' | 'tree' | 'table' = Mode.text;
  ngModel!: unknown;
  ngModelCtrl!: INgModelController;

  constructor(private $element: JQuery, private $timeout: ITimeoutService) {}

  $onInit() {
    this.$element.addClass('acme-json-editor');

    this.$timeout(() => {
      this.editor = this.createEditor();
    }, 0);
  }

  ngModelChange(value) {
    this.ngModelCtrl.$setViewValue(value);
  }

  private createEditor() {
    const target = this.$element.find(`#${this.id}`)[0];

    return createJSONEditor({
      target,
      props: {
        navigationBar: false,
        mode: Mode.text,
        content: {
          json: typeof this.ngModel === 'string' ? JSON.parse(this.ngModel) : this.ngModel,
        },
        onRenderMenu(
          items: MenuItem[],
          context: { mode: 'tree' | 'text' | 'table'; modal: boolean; readOnly: boolean }
        ) {
          const textMode = items.find((item) => item.type === 'button' && item.text === 'text');
          const treeMode = items.find((item) => item.type === 'button' && item.text === 'tree');
          const tableMode = items.find((item) => item.type === 'button' && item.text === 'table');
          const search = items.find((item) => item.type === 'button' && item.title === 'Search (Ctrl+F)');
          const undo = items.find((item) => item.type === 'button' && item.title === 'Undo (Ctrl+Z)');
          const redo = items.find((item) => item.type === 'button' && item.title === 'Redo (Ctrl+Shift+Z)');

          return [textMode, treeMode, tableMode, { type: 'separator' }, search, undo, redo].filter(Boolean);
        },
        onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
          try {
            const content = toJSONContent(updatedContent);
            const stringified = typeof content.json === 'string' ? content.json : JSON.stringify(content.json);
            this.ngModelChange(stringified);
          } catch (error) {
            // noop
          }
        },
      },
    });
  }
}

export const JsonEditorComponentModule = angular
  .module('acme.common.component.json-editor', [])
  .component('acmeJsonEditor', {
    templateUrl: 'common/components/json-editor/json-editor.component.tpl.html',
    controller: JsonEditorComponent,
    require: {
      ngModelCtrl: 'ngModel',
    },
    bindings: {
      ngModel: '<',
      mode: '<',
    },
  }).name;
